var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm.$slots.image
      ? _c("div", { staticClass: "card-image" }, [_vm._t("image")], 2)
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots.header || _vm.title
      ? _c(
          "div",
          { staticClass: "card-header" },
          [
            _vm._t("header", [
              _c("h4", { staticClass: "card-title" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-category" }, [
                _vm._v(_vm._s(_vm.subTitle))
              ])
            ])
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _vm.$slots.footer
      ? _c(
          "div",
          { staticClass: "card-footer" },
          [_c("hr"), _vm._v(" "), _vm._t("footer")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac5606d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac5606d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!../web-frontend/src/components/Cards/Card.vue
// module id = qWyc
// module chunks = 4